import React, {useState, useEffect} from 'react'
import logo from '../assets/svgs/logo.svg'
import { Link } from 'react-router-dom'
import Button from './Button'
import { useNavigate } from 'react-router-dom'



declare global {
  interface Window {
    ethereum?: any;
  }
}

const Header = ()=> {
  const navigate = useNavigate()
  const [walletAddress, setWalletAddress] = useState("");
  const [isAutoConnectEnabled, setIsAutoConnectEnabled] = useState<boolean>(false);


  useEffect(() => {
    getCurrentWalletConnected();
    addWalletListener();
  }, [walletAddress]);

  const connectWallet = async () => {
    if (typeof window !== 'undefined' && typeof window.ethereum !== 'undefined') {
      try {
        /* MetaMask is installed */
        const accounts = await window.ethereum.request({
          method: 'eth_requestAccounts',
        });
        setWalletAddress(accounts[0]);
        console.log(accounts[0]);
      } catch (err: any) {
        console.error(err.message);
      }
    } else {
      /* MetaMask is not installed */
      alert('Please install MetaMask')
      console.log('Please install MetaMask');
    }
    
  };

  const getCurrentWalletConnected = async () => {
    if (typeof window != "undefined" && typeof window.ethereum != "undefined") {
      try {
        const accounts = await window.ethereum.request({
          method: "eth_accounts",
        });
        if (accounts.length > 0) {
          setWalletAddress(accounts[0]);
          console.log(accounts[0]);
          
        } else {
          console.log("Connect to MetaMask using the Connect button");
        }
      } catch (err: any) {
        console.error(err.message);
      }
    } else {
      /* MetaMask is not installed */
      console.log("Please install MetaMask");
    }
  };
  const disconnectWallet = () => {
    setWalletAddress('');
    setIsAutoConnectEnabled(false);
    // window.location.reload();
    console.log('Wallet disconnected');
  };

  
  // Auto connect the wallet on initial load
  React.useEffect(() => {
    if (isAutoConnectEnabled) {
      connectWallet();
    }
  }, [isAutoConnectEnabled]);


  const addWalletListener = async () => {
    if (typeof window != "undefined" && typeof window.ethereum != "undefined") {
      window.ethereum.on("accountsChanged", (accounts: string[]) => {
        setWalletAddress(accounts[0]);
        console.log(accounts[0]);
      });
    } else {
      /* MetaMask is not installed */
      setWalletAddress("");
      // window.location.reload();
    }
  };

  return (
    <>
    <div className='w-[100%] h-[15vh] grid grid-cols-[36%_42%_22%] font-poppins border-b-2 [box-shadow:_0px_2px_10px_rgba(1,_126,_145,_0.1)]'>
      <div className='flex items-center pl-24'>
        <img src={logo} alt='logo'/>
      </div>
      <div className='flex items-center'>
        <nav className='text-main-black flex justify-between w-[75%]'>
            <Link to = "/">Home</Link>
            <Link to = "/dashboard">Our Services</Link>
            <Link to = "/">About Us</Link>
            <Link to = "/">Contact Us</Link>
        </nav>
      </div>
      <div className='flex items-center'> 
        <Button onClick={connectWallet}>
        <span className="is-link has-text-weight-bold">
                  {walletAddress && walletAddress.length > 0
                    ?<button onClick={() => {navigate('/dashboard')}}> Dashboard {walletAddress.substring(
                      0,
                      4
                    )}...{walletAddress.substring(39)} </button>
                    : "Connect Wallet"}
                </span>
         
        </Button>
      </div>
    </div>
    </>
  )
}

export default Header